export default __webpack_public_path__ + "static/media/property_284.a06c655a.png";